module.exports = __webpack_public_path__ + "img/seapoints-logo.e7fcface.png";